import {styled} from '@volkswagen-onehub/components-core';
import React from 'react';
import {CPOLogo} from '../../svg/CPOLogo';
import {getLang} from '../../translations';

const CpoTagContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00b0f0;
`;

const CpoTag = () => {
  const lang = getLang();

  return (
    <CpoTagContainer>
      <CPOLogo lang={lang} hideStock color="#000000" />
    </CpoTagContainer>
  );
};

export default CpoTag;
